import { jsx as _jsx } from "react/jsx-runtime";
export const EmptyPlaceholder = () => (_jsx("div", { style: {
        height: 180,
        backgroundColor: "#e0e0e0",
        borderRadius: 10,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: "#888"
    }, children: "Add a prompt to generate a component" }));
